import { Avatar } from 'antd';
import Box from 'components/Box';
import Modal from 'components/Modal';
import Text from 'components/Text';
import { SortableList } from 'features/settingService/components/SortableList';
import { sortBy } from 'lodash';
import React, { useCallback, useMemo, useState } from 'react';
import shopSelectors from 'services/shop/selectors';
import styled from 'styled-components';
import HomeConfigureButton, { HOME_CONFIGURE_BUTTON_TYPE } from '../../HomeConfigureButton';
import { useSetLoadingPage } from 'services/UI/LoadingPage';
import { IResponseDataBody } from 'services/response';
import userApis from 'features/user/services/apis';
import { useAppDispatch } from 'store/hooks';
import shopActions from 'services/shop/actions';
import userActions from 'features/user/services/actions';

const ReorderWorkingStaff = () => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState<{ id: string, name: string, avatar: string, position: string; }[]>([]);
  const setLoadingPage = useSetLoadingPage();
  const staffs = shopSelectors.data.staffs();

  const handleOpen = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    setItems(sortBy(staffs.filter(o => !o.anyBody), 'indexWorking').map(o => ({ id: o.id, name: o.nickName || o.firstName, avatar: o.urlImage || '', position: o.staffType || '' })));
    setOpen(true);
  };
  const handleAccept = async () => {
    setOpen(false);
    setLoadingPage(true);
    try {
      const res: IResponseDataBody<any> = await userApis.reorderStaffWorking(items.map(o => o.id));
      if (res.data.data) {
        dispatch(shopActions.get.staffsAvailable.fetch());
        dispatch(shopActions.get.staffs.fetch());
        dispatch(userActions.getListAvailableWorking.fetchPaging());
      }
    } catch (error) {

    } finally {
      setLoadingPage(false);
    }
  };

  const renderItem = useCallback((item: { id: string; name: string; avatar: string; position: string; }) => (
    <SortableList.Item id={item.id}>
      <CateWrap>
        <Box style={{ flex: 1 }} display='flex' alignItems='center' gap='2'>
          <Avatar
            src={item.avatar}
            size={60}
          >
            {item.name?.[0] || 'A'}
          </Avatar>
          <Text className='staff-name' style={{ flex: 1, }} variant="H7" color="text_3">
            {item.name}
          </Text>
        </Box>
        <Text className='staff-position' variant="H7" color="text_3">
          {item.position}
        </Text>
      </CateWrap>
    </SortableList.Item>
  ), []);

  return (
    <>
      <HomeConfigureButton onClick={handleOpen} type={HOME_CONFIGURE_BUTTON_TYPE.REORDER_WORKING_STAFF} />
      <Modal
        v2
        visible={open}
        onClose={() => setOpen(false)}
        onSubmit={handleAccept}
        modalTitle='Staff Working Order'
        width={600}
        containerPadding={1}
        // footerPadding={1}
        noneBodyStyle
      >
        <SortableList
          items={items}
          onChange={setItems}
          renderItem={renderItem}
        />
      </Modal>
    </>
  );
};

export default ReorderWorkingStaff;


const CateWrap = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  .label {
    font-size: 18px;
    font-weight: 600;
  }
  .staff-name {
    color: #1D2129;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: uppercase;
  }

  .staff-position {
    color: #64748B;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
